/**
 * Manager visibility API (ADR-0009, Phase F).
 *
 * Backed by /api/reports/* — the endpoints are fail-closed: a non-manager gets
 * `is_manager: false` and empty lists, so callers can probe unconditionally.
 */

import { apiFetch } from "./client";
import type { ReportConversation, ReportUser } from "./types";

export interface ReportsOverview {
  is_manager: boolean;
  reports: ReportUser[];
}

export interface ReportsConversations {
  conversations: ReportConversation[];
  reports: ReportUser[];
}

export function fetchReportsOverview(): Promise<ReportsOverview> {
  return apiFetch<ReportsOverview>("/reports/overview");
}

export function fetchReportsConversations(owner?: string): Promise<ReportsConversations> {
  const qs = owner ? `?owner=${encodeURIComponent(owner)}` : "";
  return apiFetch<ReportsConversations>(`/reports/conversations${qs}`);
}
